import { render } from "./ScoreSelector.vue?vue&type=template&id=5befc0ae&scoped=true"
import script from "./ScoreSelector.vue?vue&type=script&lang=js"
export * from "./ScoreSelector.vue?vue&type=script&lang=js"

import "./ScoreSelector.vue?vue&type=style&index=0&id=5befc0ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5befc0ae"]])

export default __exports__